import { render, staticRenderFns } from "./MoneyAttribute.vue?vue&type=template&id=e641703c"
import script from "./MoneyAttribute.vue?vue&type=script&lang=js"
export * from "./MoneyAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports